import * as type from '../../../actions/index.types'

const initialState = {
    // Tasks list
    tasksListLoading: false,
    tasksListData: null,
    tasksPagination: null,
    // Task details
    taskDetailsLoading: false,
    taskDetailsData: null,
    // Task mutations
    createTaskLoading: false,
    updateTaskLoading: false,
    deleteTaskLoading: false,
    cloneTaskLoading: false,
    // History
    taskHistoryLoading: false,
    taskHistoryData: null,
    // Workflow
    transitionTaskLoading: false,
    // Assignment
    assignTaskLoading: false,
    selfAssignTaskLoading: false,
    reassignTaskLoading: false,
    delegateTaskLoading: false,
    removeAssigneeLoading: false,
    // Watchers
    addWatcherLoading: false,
    removeWatcherLoading: false,
    // Comments
    taskCommentsLoading: false,
    taskCommentsData: null,
    addCommentLoading: false,
    uploadCommentAttachmentsLoading: false,
    // Checklist
    addChecklistLoading: false,
    toggleChecklistLoading: false,
    deleteChecklistLoading: false,
    // Dependencies
    addDependencyLoading: false,
    removeDependencyLoading: false,
    // Attachments
    uploadAttachmentLoading: false,
    deleteAttachmentLoading: false,
    // Projects
    projectsListLoading: false,
    projectsListData: null,
    projectsPagination: null,
    createProjectLoading: false,
    projectDetailsLoading: false,
    projectDetailsData: null,
    updateProjectLoading: false,
    deleteProjectLoading: false,
    // Collection
    bulkCreateTasksLoading: false,
    taskDashboardLoading: false,
    taskDashboardData: null,
    error: null,
}

const err = (action) => action?.message || 'Something went wrong.'

export function TaskReducer(state = initialState, action) {
    switch (action.type) {
        // ---------- Tasks list ----------
        case type.SOCIETY_GET_TASKS_LIST:
            return { ...state, tasksListLoading: true, error: null }
        case type.SOCIETY_GET_TASKS_LIST_SUCCESS:
            return {
                ...state,
                tasksListLoading: false,
                tasksListData: action.payload?.data ?? action.payload ?? [],
                tasksPagination: action.payload?.meta?.pagination || null,
            }
        case type.SOCIETY_GET_TASKS_LIST_FAILURE:
            return { ...state, tasksListLoading: false, error: err(action) }

        // ---------- Task details ----------
        case type.SOCIETY_GET_TASK_DETAILS:
            return { ...state, taskDetailsLoading: true, error: null }
        case type.SOCIETY_GET_TASK_DETAILS_SUCCESS:
            return { ...state, taskDetailsLoading: false, taskDetailsData: action.payload }
        case type.SOCIETY_GET_TASK_DETAILS_FAILURE:
            return { ...state, taskDetailsLoading: false, error: err(action) }

        // ---------- Create / Update / Delete / Clone ----------
        case type.SOCIETY_CREATE_TASK:
            return { ...state, createTaskLoading: true, error: null }
        case type.SOCIETY_CREATE_TASK_SUCCESS:
            return { ...state, createTaskLoading: false }
        case type.SOCIETY_CREATE_TASK_FAILURE:
            return { ...state, createTaskLoading: false, error: err(action) }

        case type.SOCIETY_UPDATE_TASK:
            return { ...state, updateTaskLoading: true, error: null }
        case type.SOCIETY_UPDATE_TASK_SUCCESS:
            return { ...state, updateTaskLoading: false, taskDetailsData: action.payload || state.taskDetailsData }
        case type.SOCIETY_UPDATE_TASK_FAILURE:
            return { ...state, updateTaskLoading: false, error: err(action) }

        case type.SOCIETY_DELETE_TASK:
            return { ...state, deleteTaskLoading: true, error: null }
        case type.SOCIETY_DELETE_TASK_SUCCESS:
            return { ...state, deleteTaskLoading: false }
        case type.SOCIETY_DELETE_TASK_FAILURE:
            return { ...state, deleteTaskLoading: false, error: err(action) }

        case type.SOCIETY_CLONE_TASK:
            return { ...state, cloneTaskLoading: true, error: null }
        case type.SOCIETY_CLONE_TASK_SUCCESS:
            return { ...state, cloneTaskLoading: false }
        case type.SOCIETY_CLONE_TASK_FAILURE:
            return { ...state, cloneTaskLoading: false, error: err(action) }

        // ---------- History ----------
        case type.SOCIETY_GET_TASK_HISTORY:
            return { ...state, taskHistoryLoading: true, error: null }
        case type.SOCIETY_GET_TASK_HISTORY_SUCCESS:
            return { ...state, taskHistoryLoading: false, taskHistoryData: action.payload }
        case type.SOCIETY_GET_TASK_HISTORY_FAILURE:
            return { ...state, taskHistoryLoading: false, error: err(action) }

        // ---------- Workflow ----------
        case type.SOCIETY_TRANSITION_TASK:
            return { ...state, transitionTaskLoading: true, error: null }
        case type.SOCIETY_TRANSITION_TASK_SUCCESS:
            return { ...state, transitionTaskLoading: false, taskDetailsData: action.payload || state.taskDetailsData }
        case type.SOCIETY_TRANSITION_TASK_FAILURE:
            return { ...state, transitionTaskLoading: false, error: err(action) }

        case type.SOCIETY_CHANGE_TASK_PRIORITY:
            return { ...state, changePriorityLoading: true, error: null }
        case type.SOCIETY_CHANGE_TASK_PRIORITY_SUCCESS:
            return { ...state, changePriorityLoading: false, taskDetailsData: action.payload || state.taskDetailsData }
        case type.SOCIETY_CHANGE_TASK_PRIORITY_FAILURE:
            return { ...state, changePriorityLoading: false, error: err(action) }

        case type.SOCIETY_CHANGE_TASK_TITLE:
            return { ...state, changeTitleLoading: true, error: null }
        case type.SOCIETY_CHANGE_TASK_TITLE_SUCCESS:
            return { ...state, changeTitleLoading: false, taskDetailsData: action.payload || state.taskDetailsData }
        case type.SOCIETY_CHANGE_TASK_TITLE_FAILURE:
            return { ...state, changeTitleLoading: false, error: err(action) }

        // ---------- Assignment ----------
        case type.SOCIETY_ASSIGN_TASK:
            return { ...state, assignTaskLoading: true, error: null }
        case type.SOCIETY_ASSIGN_TASK_SUCCESS:
            return { ...state, assignTaskLoading: false }
        case type.SOCIETY_ASSIGN_TASK_FAILURE:
            return { ...state, assignTaskLoading: false, error: err(action) }

        case type.SOCIETY_SELF_ASSIGN_TASK:
            return { ...state, selfAssignTaskLoading: true, error: null }
        case type.SOCIETY_SELF_ASSIGN_TASK_SUCCESS:
            return { ...state, selfAssignTaskLoading: false }
        case type.SOCIETY_SELF_ASSIGN_TASK_FAILURE:
            return { ...state, selfAssignTaskLoading: false, error: err(action) }

        case type.SOCIETY_REASSIGN_TASK:
            return { ...state, reassignTaskLoading: true, error: null }
        case type.SOCIETY_REASSIGN_TASK_SUCCESS:
            return { ...state, reassignTaskLoading: false }
        case type.SOCIETY_REASSIGN_TASK_FAILURE:
            return { ...state, reassignTaskLoading: false, error: err(action) }

        case type.SOCIETY_DELEGATE_TASK:
            return { ...state, delegateTaskLoading: true, error: null }
        case type.SOCIETY_DELEGATE_TASK_SUCCESS:
            return { ...state, delegateTaskLoading: false }
        case type.SOCIETY_DELEGATE_TASK_FAILURE:
            return { ...state, delegateTaskLoading: false, error: err(action) }

        case type.SOCIETY_REMOVE_TASK_ASSIGNEE:
            return { ...state, removeAssigneeLoading: true, error: null }
        case type.SOCIETY_REMOVE_TASK_ASSIGNEE_SUCCESS:
            return { ...state, removeAssigneeLoading: false }
        case type.SOCIETY_REMOVE_TASK_ASSIGNEE_FAILURE:
            return { ...state, removeAssigneeLoading: false, error: err(action) }

        // ---------- Watchers ----------
        case type.SOCIETY_ADD_TASK_WATCHER:
            return { ...state, addWatcherLoading: true, error: null }
        case type.SOCIETY_ADD_TASK_WATCHER_SUCCESS:
            return { ...state, addWatcherLoading: false }
        case type.SOCIETY_ADD_TASK_WATCHER_FAILURE:
            return { ...state, addWatcherLoading: false, error: err(action) }

        case type.SOCIETY_REMOVE_TASK_WATCHER:
            return { ...state, removeWatcherLoading: true, error: null }
        case type.SOCIETY_REMOVE_TASK_WATCHER_SUCCESS:
            return { ...state, removeWatcherLoading: false }
        case type.SOCIETY_REMOVE_TASK_WATCHER_FAILURE:
            return { ...state, removeWatcherLoading: false, error: err(action) }

        // ---------- Comments ----------
        case type.SOCIETY_GET_TASK_COMMENTS:
            return { ...state, taskCommentsLoading: true, error: null }
        case type.SOCIETY_GET_TASK_COMMENTS_SUCCESS:
            return { ...state, taskCommentsLoading: false, taskCommentsData: action.payload }
        case type.SOCIETY_GET_TASK_COMMENTS_FAILURE:
            return { ...state, taskCommentsLoading: false, error: err(action) }

        case type.SOCIETY_ADD_TASK_COMMENT:
            return { ...state, addCommentLoading: true, error: null }
        // The API returns the created comment (with author + attachments), so it is
        // appended straight to the thread — no refetch, no flicker.
        case type.SOCIETY_ADD_TASK_COMMENT_SUCCESS:
            return {
                ...state,
                addCommentLoading: false,
                taskCommentsData: action.payload?.comment_id
                    ? [...(Array.isArray(state.taskCommentsData) ? state.taskCommentsData : []), action.payload]
                    : state.taskCommentsData,
            }
        case type.SOCIETY_ADD_TASK_COMMENT_FAILURE:
            return { ...state, addCommentLoading: false, error: err(action) }

        case type.SOCIETY_UPLOAD_TASK_COMMENT_ATTACHMENTS:
            return { ...state, uploadCommentAttachmentsLoading: true, error: null }
        case type.SOCIETY_UPLOAD_TASK_COMMENT_ATTACHMENTS_SUCCESS:
            return { ...state, uploadCommentAttachmentsLoading: false }
        case type.SOCIETY_UPLOAD_TASK_COMMENT_ATTACHMENTS_FAILURE:
            return { ...state, uploadCommentAttachmentsLoading: false, error: err(action) }

        // ---------- Checklist ----------
        case type.SOCIETY_ADD_TASK_CHECKLIST:
            return { ...state, addChecklistLoading: true, error: null }
        case type.SOCIETY_ADD_TASK_CHECKLIST_SUCCESS:
            return { ...state, addChecklistLoading: false }
        case type.SOCIETY_ADD_TASK_CHECKLIST_FAILURE:
            return { ...state, addChecklistLoading: false, error: err(action) }

        case type.SOCIETY_TOGGLE_TASK_CHECKLIST:
            return { ...state, toggleChecklistLoading: true, error: null }
        case type.SOCIETY_TOGGLE_TASK_CHECKLIST_SUCCESS:
            return { ...state, toggleChecklistLoading: false }
        case type.SOCIETY_TOGGLE_TASK_CHECKLIST_FAILURE:
            return { ...state, toggleChecklistLoading: false, error: err(action) }

        case type.SOCIETY_DELETE_TASK_CHECKLIST:
            return { ...state, deleteChecklistLoading: true, error: null }
        case type.SOCIETY_DELETE_TASK_CHECKLIST_SUCCESS:
            return { ...state, deleteChecklistLoading: false }
        case type.SOCIETY_DELETE_TASK_CHECKLIST_FAILURE:
            return { ...state, deleteChecklistLoading: false, error: err(action) }

        // ---------- Dependencies ----------
        case type.SOCIETY_ADD_TASK_DEPENDENCY:
            return { ...state, addDependencyLoading: true, error: null }
        case type.SOCIETY_ADD_TASK_DEPENDENCY_SUCCESS:
            return { ...state, addDependencyLoading: false }
        case type.SOCIETY_ADD_TASK_DEPENDENCY_FAILURE:
            return { ...state, addDependencyLoading: false, error: err(action) }

        case type.SOCIETY_REMOVE_TASK_DEPENDENCY:
            return { ...state, removeDependencyLoading: true, error: null }
        case type.SOCIETY_REMOVE_TASK_DEPENDENCY_SUCCESS:
            return { ...state, removeDependencyLoading: false }
        case type.SOCIETY_REMOVE_TASK_DEPENDENCY_FAILURE:
            return { ...state, removeDependencyLoading: false, error: err(action) }

        // ---------- Attachments ----------
        case type.SOCIETY_UPLOAD_TASK_ATTACHMENT:
            return { ...state, uploadAttachmentLoading: true, error: null }
        case type.SOCIETY_UPLOAD_TASK_ATTACHMENT_SUCCESS:
            return { ...state, uploadAttachmentLoading: false }
        case type.SOCIETY_UPLOAD_TASK_ATTACHMENT_FAILURE:
            return { ...state, uploadAttachmentLoading: false, error: err(action) }

        case type.SOCIETY_DELETE_TASK_ATTACHMENT:
            return { ...state, deleteAttachmentLoading: true, error: null }
        case type.SOCIETY_DELETE_TASK_ATTACHMENT_SUCCESS:
            return { ...state, deleteAttachmentLoading: false }
        case type.SOCIETY_DELETE_TASK_ATTACHMENT_FAILURE:
            return { ...state, deleteAttachmentLoading: false, error: err(action) }

        // ---------- Projects ----------
        case type.SOCIETY_GET_TASK_PROJECTS:
            return { ...state, projectsListLoading: true, error: null }
        case type.SOCIETY_GET_TASK_PROJECTS_SUCCESS:
            return {
                ...state,
                projectsListLoading: false,
                projectsListData: action.payload?.data ?? action.payload ?? [],
                projectsPagination: action.payload?.meta?.pagination || null,
            }
        case type.SOCIETY_GET_TASK_PROJECTS_FAILURE:
            return { ...state, projectsListLoading: false, error: err(action) }

        case type.SOCIETY_CREATE_TASK_PROJECT:
            return { ...state, createProjectLoading: true, error: null }
        case type.SOCIETY_CREATE_TASK_PROJECT_SUCCESS:
            return { ...state, createProjectLoading: false }
        case type.SOCIETY_CREATE_TASK_PROJECT_FAILURE:
            return { ...state, createProjectLoading: false, error: err(action) }

        case type.SOCIETY_GET_TASK_PROJECT_DETAILS:
            return { ...state, projectDetailsLoading: true, error: null }
        case type.SOCIETY_GET_TASK_PROJECT_DETAILS_SUCCESS:
            return { ...state, projectDetailsLoading: false, projectDetailsData: action.payload }
        case type.SOCIETY_GET_TASK_PROJECT_DETAILS_FAILURE:
            return { ...state, projectDetailsLoading: false, error: err(action) }

        case type.SOCIETY_UPDATE_TASK_PROJECT:
            return { ...state, updateProjectLoading: true, error: null }
        case type.SOCIETY_UPDATE_TASK_PROJECT_SUCCESS:
            return { ...state, updateProjectLoading: false }
        case type.SOCIETY_UPDATE_TASK_PROJECT_FAILURE:
            return { ...state, updateProjectLoading: false, error: err(action) }

        case type.SOCIETY_DELETE_TASK_PROJECT:
            return { ...state, deleteProjectLoading: true, error: null }
        case type.SOCIETY_DELETE_TASK_PROJECT_SUCCESS:
            return { ...state, deleteProjectLoading: false }
        case type.SOCIETY_DELETE_TASK_PROJECT_FAILURE:
            return { ...state, deleteProjectLoading: false, error: err(action) }

        // ---------- Collection ----------
        case type.SOCIETY_BULK_CREATE_TASKS:
            return { ...state, bulkCreateTasksLoading: true, error: null }
        case type.SOCIETY_BULK_CREATE_TASKS_SUCCESS:
            return { ...state, bulkCreateTasksLoading: false }
        case type.SOCIETY_BULK_CREATE_TASKS_FAILURE:
            return { ...state, bulkCreateTasksLoading: false, error: err(action) }

        case type.SOCIETY_GET_TASK_DASHBOARD:
            return { ...state, taskDashboardLoading: true, error: null }
        case type.SOCIETY_GET_TASK_DASHBOARD_SUCCESS:
            return { ...state, taskDashboardLoading: false, taskDashboardData: action.payload }
        case type.SOCIETY_GET_TASK_DASHBOARD_FAILURE:
            return { ...state, taskDashboardLoading: false, error: err(action) }

        default:
            return state
    }
}

export default TaskReducer
